import 'css-chunksrc/client/scenes/listDuplication/listsList/list/styles.scss';export default {
  "headingWrapper": "_headingWrapper_wrky3_1",
  "contextualMenu": "_contextualMenu_wrky3_12",
  "name": "_name_wrky3_16",
  "displayedContextualMenu": "_displayedContextualMenu_wrky3_35",
  "iconBox": "_iconBox_wrky3_39",
  "icon": "_icon_wrky3_39",
  "label": "_label_wrky3_55",
  "elementsNbr": "_elementsNbr_wrky3_59",
  "main": "_main_wrky3_66",
  "lists": "_lists_wrky3_70",
  "openedIcon": "_openedIcon_wrky3_77",
  "root": "_root_wrky3_81",
  "rootHeading": "_rootHeading_wrky3_85",
  "dropBox": "_dropBox_wrky3_89",
  "droppable": "_droppable_wrky3_95",
  "droppableList": "_droppableList_wrky3_98",
  "droppableTask": "_droppableTask_wrky3_106",
  "droppableMilestone": "_droppableMilestone_wrky3_109",
  "element": "_element_wrky3_59",
  "dragged": "_dragged_wrky3_117",
  "elementLoaderWrapper": "_elementLoaderWrapper_wrky3_122",
  "elementLoader": "_elementLoader_wrky3_122",
  "empty": "_empty_wrky3_132",
  "elementCreationForm": "_elementCreationForm_wrky3_136"
};